export default "__VITE_ASSET__CJ$pfRpC__"